import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function HayirliIsler() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/subesecimi');
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      backgroundColor: '#f5f5f5',
      fontFamily: "'Helvetica Neue', sans-serif"
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '50px', marginBottom: '20px', color: '#000' }}>
          HAYIRLI İŞLER
        </h1>
        <p style={{ 
          fontSize: '24px', 
          color: '#000', 
          opacity: '0.10',
          fontFamily: "'Arial', sans-serif"
        }}>
          بِسْــــــــــــــــــمِ اﷲِالرَّحْمَنِ اارَّحِيم
        </p>
      </div>
    </div>
  );
}

export default HayirliIsler;